export default "__VITE_ASSET__BIoRd2ji__"